import React, { useEffect, useRef } from "react";

import ContainerLandpage from "containers/Landpage";
import {
  PageRoot,
  SectionContainer,
  HeroSection,
  HeroEyebrow,
  HeroTitle,
  HeroText,
  ResultsSection,
  ResultsGrid,
  ResultCard,
  ResultHeader,
  ResultTitle,
  ResultInfo,
  CompareGrid,
  CompareItem,
  CompareLabel,
  CompareImage,
  CtaSection,
  CtaCard,
  CtaTitle,
  CtaText,
  CtaButton,
} from "./styled";

const woundAlbum = {
  title: "Tratamento de feridas",
  info: "Registros de evolucao em protocolos de enfermagem especializada",
  imageFit: "contain",
  slides: [
    { label: "Registro 1", image: "/images/results/feridas/feridas-01.png" },
    { label: "Registro 2", image: "/images/results/feridas/feridas-02.png" },
    { label: "Registro 3", image: "/images/results/feridas/feridas-03.png" },
    { label: "Registro 4", image: "/images/results/feridas/feridas-04.png" },
    { label: "Registro 5", image: "/images/results/feridas/feridas-05.png" },
    { label: "Registro 6", image: "/images/results/feridas/feridas-06.png" },
    { label: "Registro 7", image: "/images/results/feridas/feridas-07.png" },
    { label: "Registro 8", image: "/images/results/feridas/feridas-08.png" },
    { label: "Registro 9", image: "/images/results/feridas/feridas-09.png" },
    { label: "Registro 10", image: "/images/results/feridas/feridas-10.png" },
    { label: "Registro 11", image: "/images/results/feridas/feridas-11.png" },
    { label: "Registro 12", image: "/images/results/feridas/feridas-12.png" },
    { label: "Registro 13", image: "/images/results/feridas/feridas-13.png" },
    { label: "Registro 14", image: "/images/results/feridas/feridas-14.png" },
    { label: "Registro 15", image: "/images/results/feridas/feridas-15.png" },
  ],
};

export default function LandpageAestheticsResults() {
  const rootRef = useRef(null);

  useEffect(() => {
    const gsap = window?.gsap;
    const ScrollTrigger = window?.ScrollTrigger;

    if (!gsap) {
      return undefined;
    }

    if (ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
    }

    const ctx = gsap.context(() => {
      gsap.utils.toArray("[data-reveal]").forEach((item) => {
        gsap.fromTo(
          item,
          { autoAlpha: 0, y: 48 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: "power3.out",
            scrollTrigger: ScrollTrigger
              ? {
                  trigger: item,
                  start: "top 84%",
                }
              : undefined,
          }
        );
      });
    }, rootRef);

    return () => ctx.revert();
  }, []);

  return (
    <ContainerLandpage variant="nursing">
      <PageRoot ref={rootRef}>
        <HeroSection id="banner" data-reveal>
          <SectionContainer vertical>
            <HeroEyebrow>Galeria de enfermagem</HeroEyebrow>
            <HeroTitle>Resultados de tratamento de feridas</HeroTitle>
            <HeroText>
              Este album pertence a pagina de enfermagem. Reune antes e depois de casos
              acompanhados com protocolos personalizados, foco em seguranca e evolucao clinica.
            </HeroText>
          </SectionContainer>
        </HeroSection>

        <ResultsSection id="results" data-reveal>
          <SectionContainer vertical>
            <ResultsGrid>
              {woundAlbum.slides.map((slide) => (
                <ResultCard key={slide.label} data-reveal>
                  <ResultHeader>
                    <ResultTitle>{woundAlbum.title}</ResultTitle>
                    <ResultInfo>
                      {slide.label} • {woundAlbum.info}
                    </ResultInfo>
                  </ResultHeader>

                  <CompareGrid>
                    <CompareItem>
                      <CompareLabel>{slide.label}</CompareLabel>
                      <CompareImage
                        src={slide.image}
                        alt={`${woundAlbum.title} ${slide.label}`}
                        $fit={woundAlbum.imageFit}
                      />
                    </CompareItem>
                  </CompareGrid>
                </ResultCard>
              ))}
            </ResultsGrid>
          </SectionContainer>
        </ResultsSection>

        <CtaSection data-reveal>
          <SectionContainer vertical>
            <CtaCard>
              <CtaTitle>Agende sua avaliacao gratuita</CtaTitle>
              <CtaText>
                Fale com a equipe e receba orientacoes iniciais para o plano
                de cuidados de enfermagem para tratamento de feridas.
              </CtaText>
              <CtaButton
                onClick={() =>
                  window.open(
                    "https://wa.me/61998333005?text=Ola%2C%20quero%20agendar%20minha%20avaliacao%20para%20tratamento%20de%20feridas.",
                    "_blank"
                  )
                }
              >
                Falar no WhatsApp
              </CtaButton>
            </CtaCard>
          </SectionContainer>
        </CtaSection>
      </PageRoot>
    </ContainerLandpage>
  );
}
